import { format } from "date-fns";
import { Status } from "../../../utils/Status";
import { Rol } from "../../../utils/Rol";

const Usuario = ({ data, onClick, navigate, user }) => {
  return (
    <tr>
      <td className="Grifter d-none d-md-table-cell">#{data.id}</td>
      <td className="d-none d-md-table-cell">{data.nombre}</td>
      <td className="d-none d-md-table-cell">{data.email}</td>
      <td className="d-none d-md-table-cell">{Rol(data.rol[0].nombre)}</td>
      <td className="d-none d-md-table-cell">
        {format(new Date(data.created_at), "dd/M/yyyy").toString()}
      </td>
      <td className="d-none d-md-table-cell">
        <div class="dropdown">
          <button
            class="btn text-dark border fw-normal GothamBold px-3 py-2 fs-10 dropdown-toggle"
            style={{ borderRadius: "10px" }}
            type="button"
            id="dropdownMenuButton1"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {data.status.nombre}
          </button>
          <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
            <li>
              <label className="btn m-0 p-0">
                <i class="text-success mx-1 bi bi-check-circle-fill"></i>
                Activar
                <button
                  className="d-none"
                  name=""
                  onClick={(event) =>
                    onClick(event, { evento: data, status: 1 })
                  }
                ></button>
              </label>
            </li>
            <li>
              <label className="btn m-0 p-0">
                <i class="text-secondary mx-1 bi bi-slash-circle-fill"></i>
                Pausar
                <button
                  className="d-none"
                  name=""
                  onClick={(event) =>
                    onClick(event, { evento: data, status: 3 })
                  }
                ></button>
              </label>
            </li>
            <li>
              <label className="btn m-0 p-0">
                <i class="text-info mx-1 bi bi-recycle"></i>
                Borradores
                <button
                  className="d-none"
                  name=""
                  onClick={(event) =>
                    onClick(event, { evento: data, status: 4 })
                  }
                ></button>
              </label>
            </li>
            <li>
              <label className="btn m-0 p-0 d-none">
                <i class="text-danger mx-1 bi bi-trash"></i>
                Eliminar
                <button
                  className="d-none"
                  name=""
                  onClick={(event) =>
                    onClick(event, { evento: data, status: 5 })
                  }
                ></button>
              </label>
            </li>
          </ul>
        </div>
      </td>

      <td>
        <label className={`btn btn-success me-1 mb-1 `}>
          <i class="bi bi-pencil-square"></i>
          <button
            className="d-none"
            name="editar-usuario"
            onClick={(e) => onClick(e, data.id)}
          ></button>
        </label>
      </td>
    </tr>
  );
};

export default Usuario;
